import { t } from 'i18next';
import styles from './EmployerPortalJobs.module.css';
import FormField from '../../UpdatedFormUI/FormField/FormField';
import BubbleButton from '../../Buttons/BubbleButton/BubbleButton';
import { SortIconList } from '../../../../assets/images/icons';
import Select, { components } from 'react-select';

export const filterUI = (setPostJobEnable, setActiveButton, formik, activeButton, getNumberOfJobs, sortOrder, setSortOrder) => {

    const FILTERBUTTONS = [
        t('filterButtons.all'),
        t('filterButtons.open'),
        t('filterButtons.paused'),
        t('filterButtons.closed')
    ];
    
    // Sort options
    const sortOptions = [
        { value: 'newest', label: t("jobs.newest") },
        { value: 'oldest', label: t("jobs.oldest") }
    ];

    const handleSortChange = (selectedOption) => {
        if (setSortOrder) {
            setSortOrder(selectedOption.value);
        }
    };

    // Custom component for the dropdown value display
    const CustomValueContainer = ({ children, ...props }) => {
        return (
            <components.ValueContainer {...props}>
                <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    height: '100%'
                }}>
                    <img src={SortIconList} alt="Sort Icon" style={{ marginRight: '8px', flexShrink: 0 }} />
                    <span style={{ 
                        fontSize: "16px", 
                        color: "#093559", 
                        flexShrink: 0,
                        marginRight: '4px'
                    }}>{t("sortBy")}</span>
                    <div style={{ 
                        minWidth: 0, 
                        overflow: 'hidden', 
                        textOverflow: 'ellipsis',
                        display: 'flex',
                        alignItems: 'center',
                        height: '100%'
                    }}>
                        {children}
                    </div>
                </div>
            </components.ValueContainer>
        );
    };
    
    // Custom component for the single value
    const CustomSingleValue = (props) => {
        return (
            <components.SingleValue {...props}>
                <div style={{ 
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%'
                }}>
                    {props.children}
                </div>
            </components.SingleValue>
        );
    };
    
    // Styles for the dropdown
    const customSelectStyles = {
        control: (provided, state) => ({
            ...provided,
            borderColor: '#8A8A8E',
            borderWidth: '1px',
            borderRadius: '10px',
            height: '44px',
            cursor: 'pointer',
            boxShadow: 'none',
            display: 'flex',
            alignItems: 'center',
            '&:hover': {
                borderColor: '#0364b2'
            },
            // Remove outline and focus borders
            outline: 'none',
            border: '1px solid #BABABA',
            '&:focus': {
                outline: 'none',
                border: '1px solid #0364b2',
            }
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '0 8px',
            overflow: 'visible',
            whiteSpace: 'nowrap',
            height: '100%',
            display: 'flex',
            alignItems: 'center'
        }),
        option: (provided, { isSelected }) => ({
            ...provided,
            backgroundColor: isSelected ? 'rgba(3, 100, 178, 0.05)' : 'white',
            color: isSelected ? '#0364b2' : '#4A4A4A',
            fontWeight: 500,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            height: '40px',
            '&:hover': {
                backgroundColor: 'rgba(3, 100, 178, 0.05)',
                color: '#0364b2'
            }
        }),
        indicatorSeparator: () => ({
            display: 'none'
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            color: '#093559',
            transition: 'all 0.3s ease',
            transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            padding: '0 8px',
            height: '100%',
            display: 'flex',
            alignItems: 'center'
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#093559',
            margin: '0',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            paddingTop: 0,
            paddingBottom: 0
        }),
        input: (provided) => ({
            ...provided,
            margin: '0',
            padding: '0',
            height: '100%'
        }),
        placeholder: (provided) => ({
            ...provided,
            margin: '0',
            display: 'flex',
            alignItems: 'center'
        }),
        // Fix menu and container styles
        menu: (provided) => ({
            ...provided,
            marginTop: '4px',
            border: '1px solid #BABABA',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            borderRadius: '10px',
            overflow: 'hidden'
        }),
        menuList: (provided) => ({
            ...provided,
            padding: '4px 0',
            borderRadius: '10px'
        })
    };

    return (
        <div className={styles.container}>
            <div className={styles.row}>
                <p className={styles.heading}>{t('employer.jobs')}</p>
                <BubbleButton
                    dark
                    headerDarkButton
                    onClick={() => { setPostJobEnable(true) }}
                    style={{ padding: '10px 20px' }}
                >
                    {t('defaultHeader.post_a_jobs')}
                </BubbleButton>
            </div>
            <div className={`${styles.filterContainer} ${styles.wrape}`}   >
                <div className={`${styles.buttonFilterContainer} ${styles.height44}`} >
                    {FILTERBUTTONS.map((item, index) => {
                        return (
                            <div
                                key={index.toString()}
                                className={styles.buttonWrapper}
                                onClick={() => setActiveButton(item)}
                            >
                                <div className={activeButton === item ? styles.activeButtonTitle : styles.buttonTitle}>{item} {getNumberOfJobs(index)}</div>
                                {index < FILTERBUTTONS.length - 1 && <div className={styles.saperator}></div>}
                            </div>
                        );
                    })}
                </div>
                <div className={`${styles.filterTitleWrapper} ${styles.height44}`} >
                    <FormField
                        name="title"
                        type="text"
                        placeholder={t('searchPlaceholderJobTitle')}
                        hasBorder
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        themeLight
                        value={formik.values.title}
                        error={formik.touched.title && formik.errors.title}
                    />
                    <div className={styles.buttonFilterContainer} style={{ width: '240px' ,border: '0px solid #BABABA'}}>
                        <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            options={sortOptions}
                            value={sortOptions.find(option => option.value === sortOrder)}
                            onChange={handleSortChange}
                            components={{ 
                                ValueContainer: CustomValueContainer,
                                SingleValue: CustomSingleValue
                            }}
                            styles={customSelectStyles}
                            isSearchable={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
};
